import { css } from "@linaria/core";
import { styled } from "@linaria/react";
import { CTA_BUTTON_COPY, FORM_IDS } from "components/data/landing-page-data";
import FormWrapper from "components/form/FormWrapper";
import RhombusForm from "components/form/RhombusForm";
import {
  SectionContainer,
  SectionInner,
  TextContainer,
} from "components/rhombus-UI/theme/containers";
import { Body, HeroTitle } from "components/rui/typography";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import React from "react";
import IndustryLogos from "./IndustryLogos";

const HeroContainer = styled(SectionContainer)`
  padding-bottom: ${(props) => (props.imageEnd ? 0 : "5rem")};
  background: var(--gradient-light);
`;

const HeroInner = styled.div`
  width: 100%;
  max-width: var(--max-width);
  display: flex;
  gap: 5rem;
  @media (max-width: 1024px) {
    flex-direction: column;
    gap: ${(props) => (props.imageEnd ? 0 : "2.5rem")};
  }
`;

const HeroSection = styled.div`
  width: 50%;
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  justify-content: center;
  gap: 2.5rem;
  @media (max-width: 1024px) {
    width: 100%;
  }
`;

const FormSection = styled(HeroSection)`
  flex-direction: row;
  justify-content: flex-end;
  padding-bottom: ${(props) => (props.imageEnd ? "5rem" : 0)};
  @media (max-width: 1024px) {
    justify-content: center;
  }
`;

const Title = styled(HeroTitle)`
  color: var(--primary-bg);
  @media (max-width: 1390px) {
    font-size: 42px;
  }
`;

const imageStyles = css`
  width: "100%";
  @media (max-width: 1024px) {
    width: 90%;
    max-width: 400px;
    align-self: center;
  }
`;

const HeroVersionG = ({
  title,
  blurb,
  imageData,
  imageEnd = true,
  logos = [],
}) => {
  return (
    <>
      <HeroContainer imageEnd={imageEnd}>
        <HeroInner imageEnd={imageEnd}>
          <HeroSection>
            <TextContainer width={"660px"}>
              <Title>{title}</Title>
              <Body>{blurb}</Body>
            </TextContainer>
            <GatsbyImage
              image={getImage(imageData)}
              loading="eager"
              className={imageStyles}
            />
          </HeroSection>
          <FormSection imageEnd={imageEnd}>
            <FormWrapper
              title={"See it to believe it. Request a Demo."}
              outline
            >
              <RhombusForm
                formId={FORM_IDS.LIVE_DEMO}
                useSecondaryButton
                customSubmitText={CTA_BUTTON_COPY}
              />
            </FormWrapper>
          </FormSection>
        </HeroInner>
      </HeroContainer>
      <IndustryLogos logos={logos} />
    </>
  );
};

export default HeroVersionG;
